import { fmtNumber } from "utils";
import { isLegacyAnnualPlan, isUsingChargebeeCustomFields, isYearlyPlan } from "utils/planUtils";

import CheckedText from "components/CheckedComponent";
import PlanCustomFields from "types/PlanCustomFields";


const credits = (amount: number, planId: string | undefined) => {
  return <CheckedText><b>{fmtNumber(amount)}</b> API Credits{ isLegacyAnnualPlan(planId) ? " / month" : (isYearlyPlan(planId) ? " / year" : "")}</CheckedText>;
};

const threads = (amount: number) => {
  return <CheckedText><b>{fmtNumber(amount)}</b> Concurrent Threads</CheckedText>;
};

const geo = (geotargeting: string) => {
  return <CheckedText>{geotargeting}</CheckedText>;
};

export const PlanAttributes: { [index: string]: { credits: number, threads: number, geo: string, crawler?: string }; } = {
  student_npo: {
    credits: 50000,
    threads: 25,
    geo: "All Geotargeting"
  },

  affiliate: {
    credits: 50000,
    threads: 20,
    geo: "US & EU Geotargeting"
  },

  yearly_affiliate: {
    credits: 600000,
    threads: 20,
    geo: "US & EU Geotargeting"
  },

  hobby_2: {
    credits: 100000,
    threads: 20,
    geo: "Geotargeting: US & EU regions only",
    crawler: "Full crawler access"
  },

  annual_hobby_2: {
    credits: 100000,
    threads: 20,
    geo: "Geotargeting: US & EU regions only",
    crawler: "Full crawler access"
  },

  yearly_hobby_2: {
    credits: 1200000,
    threads: 20,
    geo: "Geotargeting: US & EU regions only",
    crawler: "Full crawler access"
  },

  startup_2: {
    credits: 1000000,
    threads: 50,
    geo: "Geotargeting: US & EU regions only",
    crawler: "Full crawler access"
  },

  annual_startup_2: {
    credits: 1000000,
    threads: 50,
    geo: "Geotargeting: US & EU regions only",
    crawler: "Full crawler access"
  },

  yearly_startup_2: {
    credits: 12000000,
    threads: 50,
    geo: "Geotargeting: US & EU regions only",
    crawler: "Full crawler access"
  },

  business_2: {
    credits: 3000000,
    threads: 100,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  yearly_business_2: {
    credits: 36000000,
    threads: 100,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  annual_professional_1: {
    credits: 14000000,
    threads: 400,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  annual_professional_202503: {
    credits: 5000000,
    threads: 200,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  yearly_professional_202503: {
    credits: 60000000,
    threads: 200,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  scaling_202604: {
    credits: 5000000,
    threads: 200,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  annual_scaling_202604: {
    credits: 5000000,
    threads: 200,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  yearly_scaling_202604: {
    credits: 60000000,
    threads: 200,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  professional_202604: {
    credits: 12000000,
    threads: 300,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  yearly_professional_202604: {
    credits: 144000000,
    threads: 300,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  advanced_202604: {
    credits: 22000000,
    threads: 500,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  },

  yearly_advanced_202604: {
    credits: 264000000,
    threads: 500,
    geo: "Geotargeting: all country-level",
    crawler: "Full crawler access"
  }
};

export default function PlanFeatures(
  planId?: string,
  planOverrides?: Partial<PlanCustomFields>,
  maxCreditsOfAvailablePlans?: number
) {
  const planAttributes = planId ? PlanAttributes[planId] : undefined;

  if (planAttributes) {
    return [
      credits(planAttributes.credits, planId),
      threads(planAttributes.threads),
      geo(planAttributes.geo),
      planAttributes.crawler ? <CheckedText>{planAttributes.crawler}</CheckedText> : null
    ];
  } else if (isUsingChargebeeCustomFields(planId)) {
    if (planOverrides) {
      return [
        credits(planOverrides.apiCreditLimit || 0, planId),
        threads(planOverrides.apiConcurrencyLimit || 0),
        planOverrides.apiGeotargeting
      ];
    } else {
      return [
        <span className="mx-2 text-justify">Need more than {fmtNumber(maxCreditsOfAvailablePlans ?? 3000000)} API Credits with all premium features and dedicated support?</span>
      ];
    }
  }
};
